<template>
  <v-card
    class="mx-auto mt-4 rounded-card pointer"
    elevation="4"
    max-width="750"
  >
    <v-row>
      <v-col cols="12" sm="12" md="8" lg="8">
        <p style="color: #000;" class="title font-weight-bold text-truncate text-wrap">
          {{ this.name }}
        </p>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4">
        <v-btn  fab outlined color="primary">
          <v-icon class="ma-2"  @click="viewCenter"> mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <div class="container">
      <div class="row justify-content-start">
        <v-card-subtitle><span class="font-weight-black"> Address:</span> {{ this.address }} </v-card-subtitle>
      </div>

      <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-location</v-icon>
          <label> {{ this.city }} </label>
        </div>
      </div>

      <div class="row justify-content-start">
        <div class="ml-4">
          <v-icon> mdi-location</v-icon>
          <label> {{ this.country }} </label>
        </div>
      </div>

      <div class="row justify-content-start">
        <v-card-subtitle v-if="this.phoneNumber">
          <span class="font-weight-black">Phone Number:</span> {{ this.phoneNumber }}
        </v-card-subtitle>
      </div>
    </div>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  data: () => ({}),
  methods: {
    ...mapActions("donation", ["selectedDonationCenterItems"]),
    viewCenter() {
      this.selectedDonationCenterItems({
        payload: {
          centerId: this.id,
        },
      });
      this.$router.push({
        name: "DonationInventoryRegistration",
        params: {
          id: this.id,
        },
      });
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    city: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
  },
};
</script>